import type { ReactNode } from 'react';
import surface from './ProjectSurface.module.css';

interface Props {
  title: string;
  end?: ReactNode;
  className?: string;
}

/** Shared heading hierarchy for Project-level resource pages. */
export default function ProjectPageHeader({ title, end, className }: Props) {
  return (
    <header className={[surface.pageContainer, surface.pageHeader, className].filter(Boolean).join(' ')}>
      <div>
        <span className={surface.eyebrow}>Project</span>
        <h1 className={surface.pageTitle}>{title}</h1>
      </div>
      {end}
    </header>
  );
}
